import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {IoniconsOutline, NavItem, ND} from '@pt/pt-models';
import {NgxPermissionsService} from 'ngx-permissions';
import {StorageInfo} from '@primatoo-ms-organization';
import {TranslateService} from '@ngx-translate/core';
import {Observable} from 'rxjs';
import {NgbDropdown} from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'pt-sidebar-item-storage',
  template: `
    <div
      (click)="clickItem.emit(item)"
      class="sidebar-storage"
      [ngClass]="{ 'sidebar-storage--collapsed': collapsed }"
    >
      <div class="sidebar-storage-title" *ngIf="!collapsed; else menuCollapsed">
        <pt-icon [key]="IconStorage" [size]="16"></pt-icon>
        <label>{{ 'LABELS.STORAGE' | translate }}</label>
      </div>

      <div *ngIf="!collapsed" class="sidebar-storage-content text-muted">
        <pt-storage [storageInfo]="storageInfo"></pt-storage>
      </div>

      <ng-template #menuCollapsed>
        <div class="sidebar-storage-collapsed">
          <pt-icon [key]="IconStorage" [size]="16"></pt-icon>
        </div>

        <div class="sidebar-storage-collapsed-content">
          <div class="sidebar-storage-title--collapsed">
            <label>{{ 'LABELS.STORAGE' | translate }}</label>
          </div>

          <div class="sidebar-storage-content--collapsed text-muted">
            <pt-storage [storageInfo]="storageInfo"></pt-storage>
          </div>
        </div>
      </ng-template>
    </div>
  `,
  styles: [
    `
      .sidebar-storage {
        width: 100%;
        margin-top: 0;
        padding: 10px 0;
        position: relative;
        border-top: solid 1px var(--ptBorder);
      }

      .sidebar-storage-title {
        display: flex;
        justify-content: flex-start;
        align-content: center;
        flex-direction: row;
      }

      .sidebar-storage-title pt-icon {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 40px;
      }

      .sidebar-storage-title label {
        display: flex;
        align-items: center;
        justify-content: flex-start;
        margin: 0;
        width: 100%;
      }

      .sidebar-storage-content {
        padding: 5px 10px;
      }

      .sidebar-storage-title--collapsed label {
        width: 100%;
        height: 39px;
        display: flex;
        padding: 5px 10px;
        align-items: center;
        background-color: #d2d2d2;
      }

      .sidebar-storage--collapsed {
        display: flex;
        cursor: pointer;
        justify-content: center;
      }

      .sidebar-storage--collapsed:hover {
        background-color: #d2d2d2;
      }

      .sidebar-storage-content--collapsed {
        padding: 15px 20px 10px 10px;
      }

      .sidebar-storage-collapsed {
        display: flex;
      }

      .sidebar-storage:hover .sidebar-storage-collapsed-content {
        display: flex;
        flex-direction: column;
      }

      .sidebar-storage-collapsed-content {
        left: 49px;
        z-index: 2;
        display: none;
        position: fixed;
        margin-top: -11px;
        background-color: #e9e9e9;
      }
    `,
  ],
})
export class SidebarItemStorageComponent implements OnInit {
  @Input() item: NavItem;
  @Input() collapsed: boolean;
  @Input() storageInfo: StorageInfo;
  @Output() clickItem = new EventEmitter<NavItem>();

  public ND = ND;
  public isEnabled = true;
  public IconStorage = IoniconsOutline.storage;
  public of: Observable<string> = this.translateService.stream('LABELS.OF');
  public used: Observable<string> = this.translateService.stream('LABELS.USED');

  private overMenuToogle = false;
  private overMenu = false;

  constructor(
    private permissionService: NgxPermissionsService,
    private translateService: TranslateService
  ) {}

  ngOnInit(): void {
    this.permissionService
      .hasPermission(this.item.permissEnabled)
      .then((enabled) => {
        this.isEnabled = enabled;
      });
  }

  storageUsedStatus(storageInfo: StorageInfo): number {
    if (storageInfo && storageInfo.used && storageInfo.total) {
      return Math.floor((storageInfo?.used / storageInfo?.total) * 100);
    }
    return 0;
  }

  setOverToggle(isOver: boolean, myDrop: NgbDropdown) {
    this.overMenuToogle = isOver;
    if (this.overMenu || this.overMenuToogle) {
      myDrop.open();
    } else {
      myDrop.close();
    }
  }
}
